import React, {ReactElement} from 'react';
import {Typography} from '@customink/pigment-react';
import Skeleton from '@mui/material/Skeleton';
import {SvgIcon} from '@mui/material';
import PrintIcon from '../../assets/icons/print.svg?com';
import {OrderConfirmationResponse} from '../../models/orderConfirmation';
import OrderSummaryCard from './OrderConfirmationCard';
import './index.scss';

const SummaryPlaceholder: React.FC = () => {
  const mock = [1, 2, 3, 4, 5];
  return (
    <div className="orderSummaryPlaceholder">
      {mock.map(
        (row: number): ReactElement => (
          <Skeleton className="skeletonText" variant="text" key={row} />
        )
      )}
    </div>
  );
};

const OrderConfirmationSummary: React.FC<OrderConfirmationResponse> = (
  data: OrderConfirmationResponse
): ReactElement => {
  const {campaign} = data;
  if (!data || !campaign) {
    return <SummaryPlaceholder />;
  }
  return (
    <>
      <OrderSummaryCard {...campaign} />
      <div
        className="print"
        role="button"
        tabIndex={0}
        onClick={() => window.print()}
        onKeyDown={() => window.print()}>
        <SvgIcon
          viewBox="0 0 22 19"
          htmlColor="primary"
          component={PrintIcon}
        />
        <Typography className="print-text">Print Your Invoice</Typography>
      </div>
    </>
  );
};

export default OrderConfirmationSummary;
